import { actionCreatorFactory, Action } from 'typescript-fsa'
import { CollectionItem } from '../api/types'

const actionCreator = actionCreatorFactory('Navigation')

interface NavigateToCollectionPayload {
	item: CollectionItem
	parentItemId: number
}
export type CollectionListNavigationAction = Action<NavigateToCollectionPayload>
export const navigateToCollection = actionCreator<NavigateToCollectionPayload>('NAVIGATE_TO_COLLECTION')

interface NavigateToScreenPayload {
	item: CollectionItem
	parentItemId: number
}
export type ScreenNavigationAction = Action<NavigateToScreenPayload>
export const navigateToScreen = actionCreator<NavigateToScreenPayload>('NAVIGATE_TO_SCREEN')

export type NavigateToTourStopsAction = Action<NavigateToTourStopsPayload>
interface NavigateToTourStopsPayload {
	tourId: number
	tourVersion: number
	accountId?: number
	tourTitle: string
	// we use this action to either start the tour (no stop info given) or selecting a stop from the StopList (in which case stop info will be included)
	tourStopId?: number
	tourStopTitle?: string
}
export const navigateToTourStops = actionCreator<NavigateToTourStopsPayload>('NAVIGATE_TO_TOUR_STOPS')
export const navigateToTourMap = actionCreator<NavigateToTourStopsPayload>('NAVIGATE_TO_TOUR_MAP')

export type TourStopListAction = Action<TourStopListPayload>
interface TourStopListPayload {
	tourId: number
	tourVersion: number
	tourTitle: string
}
// TODO: replace TourStopListPayload to CollectionItemsListPayload
export const navigateToCollectionItemsList = actionCreator<TourStopListPayload>('NAVIGATE_TO_TOUR_STOP_LIST')

export const navigateToAppKeypadEntry = actionCreator('NAVIGATE_TO_APP_KEYPAD_ENTRY')

export const navigateToPin = actionCreator('NAVIGATE_TO_PIN')

export const navigateToQRScanner = actionCreator('NAVIGATE_TO_QR_SCANNER')

// the boolean determines whether to open or close(lock) admin settings
export type NavigateToAdminSettingsAction = Action<boolean>
export const navigateToAdminSettings = actionCreator<boolean>('NAVIGATE_TO_ADMIN_SETTINGS')
